'use strict';

require('intersection-observer');